<template>
  <div id="app" :class="'layout-'+layout">
    <div class="spacer" v-if="layout=='sm' || layout=='md'"></div>
    <div
      id="logo"
      :class="{'slim':this.currentProjectView!==null || $route.name==='contact' || layout=='sm' || layout=='md'}"
    >
      <router-link to="/">
        <div class="logo-ring"></div>
      </router-link>
    </div>
    <div id="main-nav">
      <ul>
        <li
          @click="clearProjectView()"
          :class="{'active':$route.name===nav}"
          v-for="(nav, index) in mainNavs"
          :key="index"
        >
          <router-link :to="'/'+nav">{{nav}}</router-link>
        </li>
      </ul>
    </div>
    <transition name="fade">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: "app",
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
    this.windowWidth = window.innerWidth;
    this.getProjects();
    this.getGalleries();
    this.$eventBus.$on("updateProject", this.updateProject);
    this.$eventBus.$on("updateProjectView", this.updateProjectView);
    this.$eventBus.$on("showFixedHeader", this.showFixedHeaderEvent);

    this.$router.beforeEach((to, from, next) => {
      this.$nextTick(() => {
        if (from.name === "projects" || from.name === "photography") {
          let mainCanvas = document.querySelector("#main-canvas");
          if (mainCanvas !== null) {
            mainCanvas.innerHTML = "";
          }
          this.projectGalleries = null;
          this.selectedProject = null;
          this.currentProjectView = null;
          this.enableHover = false;
        }
        next();
      });
    });
  },
  data() {
    return {
      mainNavs: ["projects", "photography", "contact"],
      enableHover: true,
      showFooter: false,
      showFixedHeader: false,
      selectedProject: null,
      currentProjectView: null,
      projects: [],
      projectGalleries: [],
      designProjects: [],
      designGalleries: [],
      photographyProjects: [],
      photoGalleries: [],
      windowWidth: 0,
      layout: "",
    };
  },
  methods: {
    getYear() {
      return new Date().getFullYear();
    },
    getImageUrl(img) {
      const imageWithExd = img.split(/\.(?=[^\.]+$)/);
      const imageName = imageWithExd[0].trim();
      const extension = imageWithExd[1].trim();
      return `http://williamsoo.com.au/assets/projects/${imageName}-${this.layout}.${extension}`;
    },

    getImageProperty(img) {
      const imageWithExd = img.split(/\.(?=[^\.]+$)/);
      const imageName = imageWithExd[0].trim();
    },
    updateProject(p) {
      if (this.enableHover) {
        this.selectedProject = p;
      }
    },
    updateProjectView(p) {
      if (this.enableHover) {
        this.currentProjectView = this.selectedProject = p;
        this.enableHover = false;
      }
    },
    showFixedHeaderEvent() {
      this.showFixedHeader = true;
    },
    noScroll() {
      window.scrollTo(0, 0);
    },
    disableScroll() {
      window.addEventListener("scroll", this.noScroll);
    },
    enableScroll() {
      window.removeEventListener("scroll", this.noScroll);
    },
    clearProjectView() {
      this.currentProjectView = null;
      if (this.layout !== "sm" && this.layout !== "md") {
        this.showFixedHeader = false;
        this.$eventBus.$emit("removeProjectView");
      } else {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }
    },
    async getProjects() {
      const projectsUrl = `https://sheets.googleapis.com/v4/spreadsheets/${
        process.env.VUE_APP_PROJECT_ID
      }/values/Sheet1?key=AIzaSyA4nWuT5bEHZJkxpMSCCoxZn8V8gthBGxM`;
      this.designProjects = await this.axios.get(projectsUrl).then((response) => {
        let data = response.data.values;
        data.shift();
        return data.map((d) => {
          return {
            id: d[0],
            name: d[1],
            category: d[2],
            cover: d[3],
            bgColor: d[4],
            description: d[5],
            websiteLink: d[6],
          };
        });
      });

      const photographyUrl = `https://sheets.googleapis.com/v4/spreadsheets/${
        process.env.VUE_APP_PHOPTGRAPHY_ID
      }/values/Sheet1?key=AIzaSyA4nWuT5bEHZJkxpMSCCoxZn8V8gthBGxM`;
      this.photographyProjects = await this.axios.get(photographyUrl).then((response) => {
        let data = response.data.values;
        data.shift();
        return data.map((d) => {
          return {
            id: d[0],
            name: d[1],
            category: d[2],
            cover: d[3],
            bgColor: d[4],
            description: d[5],
            websiteLink: d[6],
          };
        });
      });
      if (this.$route.name === "projects") {
        this.projects = this.designProjects;
        this.selectedProject = this.designProjects[0];
      } else {
        this.projects = this.photographyProjects;
        this.selectedProject = this.photographyProjects[0];
      }
    },
    async getGalleries() {
      const galleryUrl = `https://sheets.googleapis.com/v4/spreadsheets/${
        process.env.VUE_APP_GALLERY_ID
      }/values/Sheet1?key=AIzaSyA4nWuT5bEHZJkxpMSCCoxZn8V8gthBGxM`;
      this.designGalleries = await this.axios.get(galleryUrl).then((response) => {
        let data = response.data.values;
        data.shift();
        return data.map((d) => {
          return {
            id: d[0],
            images: d[2],
            path: d[1],
          };
        });
      });
      const photoGalleryUrl = ` https://sheets.googleapis.com/v4/spreadsheets/${
        process.env.VUE_APP_PHOPTGRAPHY_GALLERY_ID
      }/values/Sheet1?key=AIzaSyA4nWuT5bEHZJkxpMSCCoxZn8V8gthBGxM`;
      this.photoGalleries = await this.axios.get(photoGalleryUrl).then((response) => {
        let data = response.data.values;
        data.shift();
        return data.map((d) => {
          return {
            id: d[0],
            images: d[2],
            path: d[1],
          };
        });
      });

      if (this.$route.name === "projects") {
        this.projectGalleries = this.designGalleries;
      } else {
        this.projectGalleries = this.photoGalleries;
      }
    },
  },
  beforeDestroy() {
    this.$eventBus.$off("updateProject", this.updateProject);
    this.$eventBus.$off("updateProjectView", this.updateProjectView);
    this.$eventBus.$off("showFixedHeader", this.showFixedHeaderEvent);
  },
  watch: {
    windowWidth(newWidth) {
      this.windowWidth = newWidth;
      if (this.windowWidth < 768) {
        this.layout = "sm";
      } else if (this.windowWidth == 768 || this.windowWidth < 1280) {
        this.layout = "md";
      } else if (this.windowWidth == 1280 || this.windowWidth < 2000) {
        this.layout = "lg";
      } else if (this.windowWidth >= 2000) {
        this.layout = "xl";
      }
    },
    $route(to, from) {
      this.enableHover = true;
      this.showFooter = false;
      this.showFixedHeader = false;
      if (to.name === "projects") {
        this.projectGalleries = this.designGalleries;
        this.projects = this.designProjects;
        this.selectedProject = this.designProjects[0];
      } else if (to.name === "photography") {
        this.projectGalleries = this.photoGalleries;
        this.projects = this.photographyProjects;
        this.selectedProject = this.photographyProjects[0];
      }
    },
  },
};
</script>

<style>
@import "~animate.css/source/_base.css";
@import "~animate.css/source/sliding_entrances/slideInUp.css";
@import "~animate.css/source/sliding_exits/slideOutDown.css";

@import "~animate.css/source/fading_entrances/fadeInUp.css";
@import "~animate.css/source/fading_entrances/fadeInLeft.css";
@import "~animate.css/source/fading_entrances/fadeIn.css";

@import "~animate.css/source/fading_exits/fadeOutRight.css";
@import "~animate.css/source/fading_exits/fadeOutDown.css";
@import "~animate.css/source/fading_exits/fadeOut.css";

@import "~animate.css/source/attention_seekers/pulse.css";
@import "~mini.css/dist/mini-default.css";
html,
body {
  padding: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: white;
}
a,
a:hover {
  text-decoration: none;
}
#app {
  width: 100%;
  height: 100%;
  display: flex;
}
.spacer {
  height: 46px;
  width: 100%;
  position: fixed;
  z-index: 998;
  background-color: white;
}
#logo {
  top: 10%;
  left: 10px;
  z-index: 999;
  background-image: url("/assets/Ws-logo.png");
  background-position: center center;
  width: 149px;
  height: 152px;
  display: block;
  position: fixed;
  background-color: white;
  border-radius: 100px;
  transition: 0.8s all cubic-bezier(0.8, 0.03, 0.25, 1);
}
.logo-ring {
  width: 100%;
  height: 100%;
  background-image: url("/assets/Ws-logo-ring.png");
  background-position: center center;
  opacity: 1;
  transition: 0.8s all cubic-bezier(0.8, 0.03, 0.25, 1);
}
.slim .logo-ring {
  transform: rotate(-90deg);
  opacity: 0;
}

.slim {
  width: 89px !important;
  height: 89px !important;
  left: 0 !important;
}
#main-container {
  color: #2c3e50;
  display: flex;
  height: 100%;
}

#main-nav {
  position: fixed;
  width: calc(100vh - 89px);
  height: 90px;
  border-bottom: #999 solid 1px;
  box-sizing: border-box;
  transform: rotate(-90deg) translate(-100vh, 0);
  transform-origin: top left;
  background: white;
  transition: all 0.4s ease;
}

#main-nav ul {
  margin: 0 auto;
  padding: 0;
  display: flex;
  justify-content: center;
  list-style: none;
  transform: translateY(34px);
}

#main-nav ul a {
  font-size: 0.7em;
  font-weight: bold;
  color: #999;
  padding: 0.5em 2em;
  text-transform: uppercase;
  transition: color 0.5s ease-in-out;
  text-decoration: none;
}

#main-nav ul a:hover,
#main-nav ul li.active > a {
  color: black;
}

.layout-md #main-nav,
.layout-sm #main-nav {
  margin-top: 45px;
  width: 100%;
  height: 90px;
  border-top: #999 solid 1px;
  border-bottom: #999 solid 1px;
  z-index: 999;
  transform: none;
}

.layout-md #logo,
.layout-sm #logo {
  top: 0;
  left: 50% !important;
  transform: translateX(-50%);
  z-index: 99999;
  width: 89px !important;
}

.fade-enter-active {
  opacity: 1;
  transition: opacity 0.5s;
  left: 0;
}
.fade-leave-active {
  opacity: 0;
  transition: opacity 0.5s;
  position: fixed !important;
}
</style>
